import { Building2, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/common/EmptyState';
import { PANEL_URL } from '@/config/brand';

export default function MyListings() {
  return (
    <div>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-2xl font-semibold text-slate-900">My listings</h1>
          <p className="text-sm text-slate-600">Listings are managed in the CasaHom panel</p>
        </div>
        <Button
          className="rounded-xl"
          data-testid="add-listing-button"
          onClick={() => { window.location.href = PANEL_URL; }}
        >
          <ExternalLink size={16} className="mr-1.5" />
          Open panel
        </Button>
      </div>

      <div className="mt-6">
        <EmptyState
          icon={Building2}
          title="Managed in the panel"
          description="Create and manage property listings in your CasaHom panel. This SPA does not create listings."
          actionLabel="Go to panel"
          onAction={() => { window.location.href = PANEL_URL; }}
        />
      </div>
    </div>
  );
}
